import { useMemo } from "react";
import { marked } from "marked";
import { Link } from "wouter";
import { useStaticPage } from "@/lib/cms";

export function StaticPagePage({ slug }: { slug: string }) {
  const q = useStaticPage(slug);

  const html = useMemo(() => {
    if (!q.data?.content) return "";
    // marked is synchronous when called without async option; cast to string.
    return marked.parse(q.data.content, { async: false }) as string;
  }, [q.data?.content]);

  if (q.isLoading) {
    return (
      <div className="container py-24 text-brand-500">Betöltés...</div>
    );
  }

  if (q.isError || !q.data) {
    return (
      <div className="container py-24 text-center">
        <h1 className="section-title text-3xl">Az oldal nem található</h1>
        <Link href="/" className="btn-primary mt-6 inline-flex">
          Vissza a kezdőlapra
        </Link>
      </div>
    );
  }

  return (
    <div className="container max-w-3xl py-16 lg:py-24">
      <article
        className="prose-page"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}
